import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as ModelIcon } from '../../assets/icons/sidebar/sidebar-device.svg';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { setPageTitle } from '../../redux/slices/PageTitleSlice';

import Local from './components/Local';

/**
 * Model management page — displays local device models.
 * @returns {React.JSX.Element} ModelManagement page
 */
function ModelManagement() {
  const { t } = useTranslation('deviceHub');
  const dispatch = useAppDispatch();
  const { totalResults: localTotal } = useAppSelector((state) => state.model);

  useEffect(() => {
    dispatch(
      setPageTitle({
        title: t('models'),
        count: localTotal,
        icon: <ModelIcon />,
      }),
    );
  }, [dispatch, localTotal]);

  return (
    <div className="model-management-wrap">
      <div className="model-management-container">
        <div className="table-content">
          <Local />
        </div>
      </div>
    </div>
  );
}

export default ModelManagement;
